export default {
  svgPath: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 4.27273C2.5 3.01754 3.51754 2 4.77273 2H8.04545V0H4.77273C2.41297 0 0.5 1.91297 0.5 4.27273V15.7273C0.5 18.087 2.41296 20 4.77273 20H8.04545V18H4.77273C3.51753 18 2.5 16.9825 2.5 15.7273V4.27273ZM13.2628 14.2334L16.2268 11L5.40909 11V9L16.0858 9L13.2929 6.20711L14.7071 4.79289L19.2071 9.29289L19.8841 9.96993L19.2372 10.6757L14.7372 15.5848L13.2628 14.2334Z" fill="#111111"/>
  `,
  title: 'Logout Icon',
  viewBox: '0 0 21 20',
};
